import React from "react";
import { Menu } from "antd";
import { NavLink } from "react-router-dom";

const { SubMenu } = Menu;

interface MenuItemWithSeparatorProps {
    isVisibleSeparator?: boolean;
    children: any
}

const MenuItemWithSeparator = (props: MenuItemWithSeparatorProps) => (
    <>
        <Menu.Item>
            {props.children}
        </Menu.Item>

        {
            props.isVisibleSeparator ?
                <></>
                : <Menu.Item className="menu-separator">|</Menu.Item>
        }
    </>
);

const Footer = () => {
    return (
        <div className="footer-content">
            <div style={{ display: "none" }}>
                <Menu
                    mode="horizontal"
                    className="nav-menu"
                >
                    <MenuItemWithSeparator>
                        <NavLink to="/" exact activeClassName="active-link">
                            Anasayfa
                        </NavLink>
                    </MenuItemWithSeparator>

                    <SubMenu key="hakkimizda" title="Hakkımızda" className="submenu-content">
                        <Menu.Item key="baskan-hakkinda">
                            <NavLink to="/hakkimizda/baskan-hakkinda">Ali Yakub Baba Hakkında</NavLink>
                        </Menu.Item>
                        <Menu.Item key="size-olan-mesajimiz">
                            <NavLink to="/hakkimizda/size-olan-mesajimiz">Size Olan Mesajımız</NavLink>
                        </Menu.Item>
                    </SubMenu>

                    <Menu.Item className="menu-separator">|</Menu.Item>

                    <SubMenu key="mursidlerim" title="Mürşidlerim" className="submenu-content">
                        <Menu.Item key="muzaffer-aski-ozak">
                            <NavLink to="/mursidlerim/muzaffer-aski-ozak">Muzaffer Aşkî Ozak</NavLink>
                        </Menu.Item>
                        <Menu.Item key="sefer-dal">
                            <NavLink to="/mursidlerim/sefer-dal">Sefer Dal</NavLink>
                        </Menu.Item>
                    </SubMenu>

                    <Menu.Item className="menu-separator">|</Menu.Item>

                    <MenuItemWithSeparator>
                        <NavLink to="/sema" activeClassName="active-link">
                            Sema
                        </NavLink>
                    </MenuItemWithSeparator>

                    <MenuItemWithSeparator>
                        <NavLink to="/books" activeClassName="active-link">
                            Kitaplar
                        </NavLink>
                    </MenuItemWithSeparator>

                    <MenuItemWithSeparator>
                        <NavLink to="/hacc-hatiralari" activeClassName="active-link">
                            Hacc
                        </NavLink>
                    </MenuItemWithSeparator>

                    <MenuItemWithSeparator>
                        <NavLink to="/itikaf-hatiralari" activeClassName="active-link">
                            İtikaf
                        </NavLink>
                    </MenuItemWithSeparator>

                    <MenuItemWithSeparator>
                        <NavLink to="/mukabele" activeClassName="active-link">
                            Mukabele
                        </NavLink>
                    </MenuItemWithSeparator>

                    <MenuItemWithSeparator isVisibleSeparator={true}>
                        <NavLink to="/galeri" activeClassName="active-link">
                            Galeri
                        </NavLink>
                    </MenuItemWithSeparator>
                </Menu>

            </div>
            <div className="copyright-bar" style={{ padding: 12 }}>
                © 2024 • Her hakkı mahfuzdur
            </div>
        </div>
    );
}

export default Footer;